import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Box,
  Typography,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore.js';
import { menuRoutes } from '@/config/appRoutes.js';

export const Sidebar = ({
  open,
  onClose,
  isDesktop,
  width = 200,
}: {
  open: boolean;
  onClose: () => void;
  isDesktop: boolean;
  width?: number;
}) => {
  const location = useLocation();
  const hasPermission = useAuthStore((s) => s.hasPermission);

  const drawerContent = (
    <>
      <Toolbar />
      <Box sx={{ p: 2, pb: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
          Menu
        </Typography>
      </Box>
      <List>
        {menuRoutes
          .filter((item) => !item.requiredPermission || hasPermission(item.requiredPermission))
          .map((item) => {
            const Icon = item.icon;
            return (
              <ListItem key={item.path} disablePadding>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  selected={location.pathname === item.path}
                  onClick={onClose}
                >
                  <ListItemIcon>
                    <Icon />
                  </ListItemIcon>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            );
          })}
      </List>
    </>
  );

  if (isDesktop) {
    return (
      <Drawer
        variant="permanent"
        open={open}
        sx={{
          width: open ? width : 0,
          flexShrink: 0,
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width },
          transition: (theme) =>
            theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
        }}
      >
        {drawerContent}
      </Drawer>
    );
  }

  return (
    <Drawer
      variant="temporary"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        '& .MuiDrawer-paper': { boxSizing: 'border-box', width },
      }}
    >
      {drawerContent}
    </Drawer>
  );
};
